/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CalendarSubscription,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Generate calendar subscription token
 */
export const createFleetCalendarSubscription = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<CalendarSubscription>(
      {url: `/fleets/${fleetSlug}/calendar/subscription`, method: 'POST', signal
    },
      );
    }




export const getCreateFleetCalendarSubscriptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext> => {

const mutationKey = ['createFleetCalendarSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetCalendarSubscription>>, {fleetSlug: string}> = (props) => {
          const {fleetSlug} = props ?? {};

          return  createFleetCalendarSubscription(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetCalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetCalendarSubscription>>>

    export type CreateFleetCalendarSubscriptionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Generate calendar subscription token
 */
export const useCreateFleetCalendarSubscription = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetCalendarSubscription>>,
        TError,
        {fleetSlug: string},
        TContext
      > => {
      return useMutation(getCreateFleetCalendarSubscriptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Disable calendar subscription
 */
export const destroyFleetCalendarSubscription = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/calendar/subscription`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetCalendarSubscriptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext> => {

const mutationKey = ['destroyFleetCalendarSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetCalendarSubscription>>, {fleetSlug: string}> = (props) => {
          const {fleetSlug} = props ?? {};

          return  destroyFleetCalendarSubscription(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetCalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetCalendarSubscription>>>

    export type DestroyFleetCalendarSubscriptionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Disable calendar subscription
 */
export const useDestroyFleetCalendarSubscription = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetCalendarSubscription>>,
        TError,
        {fleetSlug: string},
        TContext
      > => {
      return useMutation(getDestroyFleetCalendarSubscriptionMutationOptions(options), queryClient);
    }
    /**
 * @summary Show calendar subscription
 */
export const fleetCalendarSubscription = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<CalendarSubscription>(
      {url: `/fleets/${fleetSlug}/calendar/subscription`, method: 'GET', signal
    },
      );
    }




export const getFleetCalendarSubscriptionQueryKey = (fleetSlug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'calendar','subscription'
    ] as const;
    }


export const getFleetCalendarSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof fleetCalendarSubscription>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetCalendarSubscription>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetCalendarSubscriptionQueryKey(fleetSlug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetCalendarSubscription>>> = ({ signal }) => fleetCalendarSubscription(fleetSlug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetCalendarSubscription>>, TError, TData>
}

export type FleetCalendarSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof fleetCalendarSubscription>>>
export type FleetCalendarSubscriptionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show calendar subscription
 */

export function useFleetCalendarSubscription<TData = Awaited<ReturnType<typeof fleetCalendarSubscription>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetCalendarSubscription>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetCalendarSubscriptionQueryOptions(fleetSlug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Rotate calendar subscription token
 */
export const rotateFleetCalendarSubscription = (
    fleetSlug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);

      return axiosClient<CalendarSubscription>(
      {url: `/fleets/${fleetSlug}/calendar/subscription/rotate`, method: 'POST', signal
    },
      );
    }




export const getRotateFleetCalendarSubscriptionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rotateFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext> => {

const mutationKey = ['rotateFleetCalendarSubscription'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateFleetCalendarSubscription>>, {fleetSlug: string}> = (props) => {
          const {fleetSlug} = props ?? {};

          return  rotateFleetCalendarSubscription(fleetSlug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateFleetCalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof rotateFleetCalendarSubscription>>>

    export type RotateFleetCalendarSubscriptionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Rotate calendar subscription token
 */
export const useRotateFleetCalendarSubscription = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateFleetCalendarSubscription>>, TError,{fleetSlug: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof rotateFleetCalendarSubscription>>,
        TError,
        {fleetSlug: string},
        TContext
      > => {
      return useMutation(getRotateFleetCalendarSubscriptionMutationOptions(options), queryClient);
    }
